export default {
  currentStep: 1,
  maxStep: 1,
  modalPlanDetails: false,
  card: null,
  customer: null,
  billingInfo: null,
  modalpayment: false,
  componentOpenedInModal: null,
  maxAudience: 500,
  maxEmailsIncluded: 2000,
  selectedPlanId: '',
  selectedTierId: '',
  selectedPlanName: '',
  paymentPeriod: 1,
  mount: 0, //corrigir para amount
  selectPayment: null,
  messageModal: null,
  setupIntentClientSecret: null,
  setupIntent: null,
}
